/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacySnackBarRef as MatSnackBarRef, MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';
import { SNACKBAR_NOTIFICATION_TYPE } from '@core/constants';

@Component({
  selector: 'zuum-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class IconSnackBarComponent implements OnInit {
  icon: any;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private _snackRef: MatSnackBarRef<IconSnackBarComponent>) {}

  ngOnInit(): void {
    this.getIcon();
  }

  getIcon(): void {
    if (this.data.type === SNACKBAR_NOTIFICATION_TYPE.SUCCESS) {
      this.icon = 'done';
    } else if (this.data.type === SNACKBAR_NOTIFICATION_TYPE.ERROR) {
      this.icon = 'error_outline';
    } else if (this.data.type === SNACKBAR_NOTIFICATION_TYPE.WARNING) {
      this.icon = 'warning';
    } else if (this.data.type === SNACKBAR_NOTIFICATION_TYPE.INFO) {
      this.icon = 'info';
    }
  }

  close(): void {
    this._snackRef.dismiss();
  }
}
